import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const DOCUMENT_CREATE = (params) => { return URI(`${API_BASE}/api/v2/documents/`).addSearch(params) }
export const DOCUMENT_INFO = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/documents/${id}/`).addSearch(params) }
export const DOCUMENTS_LIST = (params) => { return URI(`${API_BASE}/api/v2/documents/`).addSearch(params) }
export const DOCUMENT_CATEGORIES = (params) => { return URI(`${API_BASE}/api/v2/documents/document_categories/`).addSearch(params) }
